<div class="container py-3 mt-5">
  <div style="margin-bottom: 20px">
  <app-anagrafica [schedaMorte]="this"></app-anagrafica>
  </div>

  <ul class="nav nav-tabs" style="cursor: pointer;">
    <li class="nav-item">
      <a (click)="goToParteA()" class="nav-link title-4" [ngStyle]="{'color': (isParteA) ? '#0d6efd' : '#495057'}"
         [ngClass]="{'active': (isParteA)}">Parte A</a>
    </li>
    <li class="nav-item">
      <a (click)="goToParteB()" class="nav-link title-4" [ngStyle]="{'color': (isParteB) ? '#0d6efd' : '#495057'}"
         [ngClass]="{'active': (isParteB)}">Parte B</a>
    </li>
  </ul>
  <div *ngIf="isParteA">
    <app-parte-a [schedaMorte]="this" *ngIf="dataLoaded"></app-parte-a>
  </div>
  <div *ngIf="isParteB">
    <app-parte-b [schedaMorte]="this" *ngIf="dataLoaded"></app-parte-b>
  </div>

  <div class="btn-fixed fixed">
    <div class="btn-toolbar">
      <div class="container">
        <div class="btn-group-left">
          <button *ngIf="(form.pristine && modalita ) || !modalita" class="btn btn-outline-secondary" (click)="annulla()">Torna alla lista
          </button>
        </div>
        <div class="btn-group-right"></div>
        <div class="btn-group-right">
          <div class="inRow" style="gap: 0 20px;justify-content: flex-end;">
            <button *ngIf="!modalita && modificaAbilitata" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modalElimina">Elimina</button>
            <button *ngIf="modalita && modificaAbilitata" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modalAnnulla">Annulla</button>
            <button *ngIf="modalita && modificaAbilitata" class="btn btn-primary" (click)="save()">Salva</button>
            <button *ngIf="!modalita && modificaAbilitata" class="btn btn-primary" (click)="setModifica()">Modifica</button>
            <label *ngIf="schedaInviata">Scheda già inviata e non modificabile</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Elimina -->
  <div class="modal fade" id="modalElimina" tabindex="-1" aria-labelledby="modalElimina" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Eliminazione scheda</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Una volta eliminata la scheda i dati inseriti verranno persi, sei sicuro di voler uscire?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
          <button type="button" class="btn btn-primary" (click)="eliminaScheda()" data-bs-dismiss="modal">Elimina scheda</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Annulla -->
  <div class="modal fade" id="modalAnnulla" tabindex="-1" aria-labelledby="modalAnnulla" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Annullamento scheda</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Una volta chiusa la scheda i dati inseriti verranno persi, sei sicuro di voler uscire?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
          <button type="button" class="btn btn-primary" (click)="annulla()" data-bs-dismiss="modal">Esci dalla scheda</button>
        </div>
      </div>
    </div>
  </div>
</div>
